import Vue from 'vue';
import './plugins/element.js';
import './scss/reset.scss';
import './scss/base.scss';
import './assets/iconfont/iconfont.css';
import './assets/font/font.scss';
import { MyPlugin } from 'drcnet-common/dist/js/common';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(MyPlugin);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
